import { VueConstructor } from 'vue';

export function makeInjector<TProvider>() {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	return function<V extends Vue, K extends keyof TProvider> (v: VueConstructor<V>, properties: K[]) {
		return v as VueConstructor<V & Pick<TProvider, K>>;
	};
}

export function makePropertySelector<TProvider>() {
	return function<K extends keyof TProvider> (properties: K[]) {
		return properties;
	};
}
